<app-dialog
  #dialog
  [key]="'modal-company-invoicing'"
  [action]="'company-invoicing'"
  [headerTheme]="'simple'"
  [title]="'Faturamento'"
  [showMaximizeButton]="true"
  [maxWidth]="'95vw'"
  [maxHeight]="'100vh'">
  <div class="invoicing-modal">
    <!-- Company Banner -->
    <div class="company-banner" *ngIf="company">
      <h3 class="company-name">{{ company.displayName }}</h3>
      <span class="company-cnpj" *ngIf="company.cnpj">CNPJ: {{ company.cnpj }}</span>
    </div>

    <!-- ========== SEÇÃO 1: PARÂMETROS DE FATURAMENTO ========== -->
    <div class="section-wrapper">
      <div class="section-banner green">
        <i class="pi pi-file-edit"></i>
        <span class="section-title-text">Parâmetros de Faturamento</span>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoadingInvoicing" class="loading-container">
        <app-cog-loading-spinner></app-cog-loading-spinner>
        <p>Carregando parâmetros de faturamento...</p>
      </div>

      <!-- Form Content -->
      <div *ngIf="!isLoadingInvoicing">
        <!-- Fee Type Selection -->
        <div class="fee-selection-container">
          <div
            class="fee-radio-card"
            [class.selected]="selectedFeeType === 'FlatFee'"
            (click)="onFeeTypeChange('FlatFee')">
            <div>
              <div class="fee-radio-title">Flat Fee</div>
              <div class="fee-radio-desc">Taxa fixa sobre o valor</div>
            </div>
            <input
              type="radio"
              [checked]="selectedFeeType === 'FlatFee'"
              name="feeType"
              aria-label="Selecionar Flat Fee" />
          </div>

          <div
            class="fee-radio-card"
            [class.selected]="selectedFeeType === 'SuccessFee'"
            (click)="onFeeTypeChange('SuccessFee')">
            <div>
              <div class="fee-radio-title">Success Fee</div>
              <div class="fee-radio-desc">Taxa sobre a diferença</div>
            </div>
            <input
              type="radio"
              [checked]="selectedFeeType === 'SuccessFee'"
              name="feeType"
              aria-label="Selecionar Success Fee" />
          </div>
        </div>

        <!-- Flat Fee Parameters -->
        <app-form-card
          *ngIf="selectedFeeType === 'FlatFee'"
          icon="pi pi-percentage"
          title="Percentual Flat Fee"
          description="Configuração do percentual para taxa fixa">
          <div class="fields-grid">
            <div class="field-container">
              <app-input
                theme="medium"
                type="number"
                [totalFractionDigits]="2"
                [(ngModel)]="flatFeePercentage"
                [label]="'Percentual (%)'"
                [placeholder]="'0,00'"
                [min]="0"
                [max]="100"
                suffix="%"
                [required]="true" />
            </div>
          </div>
        </app-form-card>

        <!-- Success Fee Parameters -->
        <app-form-card
          *ngIf="selectedFeeType === 'SuccessFee'"
          icon="pi pi-chart-line"
          title="Percentual Success Fee"
          description="Configuração do percentual para taxa sobre diferença">
          <div class="fields-grid">
            <div class="field-container">
              <app-input
                theme="medium"
                type="number"
                [totalFractionDigits]="2"
                [(ngModel)]="successFeePercentage"
                [label]="'Percentual (%)'"
                [placeholder]="'0,00'"
                [min]="0"
                [max]="100"
                suffix="%"
                [required]="true" />
            </div>
          </div>
          <div class="formula-preview">
            <div class="preview-card">
              <i class="pi pi-info-circle"></i>
              <div class="preview-content">
                <strong>Fórmula:</strong>
                <span class="preview-text"
                  >(Valor Base - Valor Novo) × {{ successFeePercentage || 0 }}%</span
                >
              </div>
            </div>
          </div>
        </app-form-card>

        <!-- Tax Configuration -->
        <app-form-card
          icon="pi pi-calculator"
          title="Impostos"
          description="Aplicar impostos sobre o valor calculado">
          <div class="config-toggle-wrapper" slot="actions">
            <div class="toggle-switch-wrapper">
              <span class="toggle-label-text">{{ applyTaxes ? 'Ativado' : 'Desativado' }}</span>
              <div class="toggle-switch" [class.active]="applyTaxes">
                <input
                  type="checkbox"
                  [(ngModel)]="applyTaxes"
                  (change)="onTaxToggle($any($event.target).checked)"
                  class="toggle-input"
                  id="taxToggle"
                  aria-label="Ativar aplicação de impostos" />
                <label for="taxToggle" class="toggle-label"></label>
              </div>
            </div>
          </div>
          <div class="fields-grid" [class.disabled]="!applyTaxes">
            <div class="field-container">
              <app-input
                theme="medium"
                type="number"
                [totalFractionDigits]="2"
                [(ngModel)]="taxPercentage"
                [label]="'Percentual de Imposto (%)'"
                [placeholder]="'19,53'"
                [min]="0"
                [max]="100"
                [disabled]="!applyTaxes"
                suffix="%"
                [required]="applyTaxes" />
            </div>
          </div>
          <div class="default-value-preview">
            <div class="preview-card">
              <i class="pi pi-info-circle"></i>
              <div class="preview-content">
                <strong>Valor padrão:</strong>
                <span class="preview-text">19,53%</span>
              </div>
            </div>
          </div>
        </app-form-card>

        <!-- Desk Fee Configuration -->
        <app-form-card
          icon="pi pi-briefcase"
          title="Taxa da Mesa"
          description="Taxa adicional de operação">
          <div class="config-toggle-wrapper" slot="actions">
            <div class="toggle-switch-wrapper">
              <span class="toggle-label-text">{{ applyDeskFee ? 'Ativado' : 'Desativado' }}</span>
              <div class="toggle-switch" [class.active]="applyDeskFee">
                <input
                  type="checkbox"
                  [(ngModel)]="applyDeskFee"
                  (change)="onDeskFeeToggle($any($event.target).checked)"
                  class="toggle-input"
                  id="deskFeeToggle"
                  aria-label="Ativar taxa da mesa" />
                <label for="deskFeeToggle" class="toggle-label"></label>
              </div>
            </div>
          </div>
          <div class="fields-grid" [class.disabled]="!applyDeskFee">
            <div class="field-container">
              <app-input
                theme="medium"
                type="number"
                [totalFractionDigits]="2"
                [(ngModel)]="deskFeePercentage"
                [label]="'Percentual da Taxa da Mesa (%)'"
                [placeholder]="'0,20'"
                [min]="0"
                [max]="100"
                [disabled]="!applyDeskFee"
                suffix="%"
                [required]="applyDeskFee" />
            </div>
          </div>
          <div class="default-value-preview">
            <div class="preview-card">
              <i class="pi pi-info-circle"></i>
              <div class="preview-content">
                <strong>Valor padrão:</strong>
                <span class="preview-text">0,20%</span>
              </div>
            </div>
          </div>
        </app-form-card>

        <!-- Configuration Summary -->
        <div class="summary-section-container" *ngIf="selectedFeeType">
          <div class="summary-title">Resumo da Configuração</div>
          <div class="summary-box-clean">
            <div class="summary-row">
              <span class="summary-label">Tipo de Taxa:</span>
              <span class="summary-value-text">{{ getFeeTypeLabel(selectedFeeType) }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Percentual:</span>
              <span class="summary-value-number">
                {{ selectedFeeType === 'FlatFee' ? flatFeePercentage : successFeePercentage }}%
              </span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Impostos:</span>
              <span class="summary-value-number" *ngIf="applyTaxes; else taxesInactive">
                {{ taxPercentage }}%
              </span>
              <ng-template #taxesInactive>
                <span class="summary-value-inactive">Não aplicável</span>
              </ng-template>
            </div>
            <div class="summary-row">
              <span class="summary-label">Taxa da Mesa:</span>
              <span class="summary-value-number" *ngIf="applyDeskFee; else deskFeeInactive">
                {{ deskFeePercentage }}%
              </span>
              <ng-template #deskFeeInactive>
                <span class="summary-value-inactive">Não aplicável</span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========== SEÇÃO 2: BENCHMARK ========== -->
    <div class="section-wrapper">
      <div class="section-banner blue">
        <i class="pi pi-chart-line"></i>
        <span class="section-title-text">Benchmark</span>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoadingBenchmark" class="loading-container">
        <app-cog-loading-spinner></app-cog-loading-spinner>
        <p>Carregando informações do benchmark...</p>
      </div>

      <!-- Form Content -->
      <div *ngIf="!isLoadingBenchmark">
        <!-- Benchmark Form -->
        <form [formGroup]="benchmarkForm" appAutoFormGroup class="benchmark-form">
          <app-form-card
            icon="pi pi-sliders-h"
            title="Configuração Padrão"
            description="Configure o indexador e spread global">
            <div class="fields-grid">
              <div class="field-container">
                <app-select
                  [controlName]="benchmarkFormProps.indexer"
                  [label]="'Indexador'"
                  [placeholder]="'Selecione o indexador'"
                  [options]="indexerOptions">
                </app-select>
              </div>

              <div class="field-container">
                <app-input
                  [type]="'number'"
                  [controlName]="benchmarkFormProps.percentage"
                  [label]="'Spread (%)'"
                  [placeholder]="'0,00'"
                  [totalFractionDigits]="2"
                  [required]="true"
                  [min]="0"
                  [max]="100">
                </app-input>
                <small class="form-help">Ex: CDI+4% (CDI + 4% a.a.)</small>
              </div>
            </div>

            <!-- Preview do Benchmark -->
            <div class="benchmark-preview" *ngIf="benchmarkForm.valid">
              <div class="preview-card">
                <i class="pi pi-info-circle"></i>
                <div class="preview-content">
                  <strong>Preview:</strong>
                  <span class="preview-text">
                    {{ getSelectedIndexerLabel() }} + {{ getPercentageValue() }}%
                  </span>
                </div>
              </div>
            </div>
          </app-form-card>
        </form>

        <!-- Loan Operations Table -->
        <app-form-card
          icon="pi pi-list"
          title="Empréstimos da Empresa"
          description="Lista de empréstimos vinculados"
          customClass="loans-card">
          <!-- Loading State -->
          <div *ngIf="isLoadingLoans" class="loading-container">
            <app-cog-loading-spinner></app-cog-loading-spinner>
            <p>Carregando empréstimos...</p>
          </div>

          <!-- Table Content -->
          <div *ngIf="!isLoadingLoans">
            <app-table
              [items]="loanOperations"
              [columnDefinitions]="loanColumns"
              [hasPagination]="true"
              [hasCheckbox]="false"
              [showSearch]="true"
              [totalRecords]="loanOperationsTotal"
              [rows]="loanOperationsPageSize"
              [getOptionsFunction]="getMenuActions.bind(this)"
              (sendTableAction)="handleLoanTableAction($event)"
              (sendTablePagination)="handleLoanTablePagination($event)"
              (sendTableFilter)="handleLoanTableSearch($event)">
              <!-- Template para Banco (com ícone) - igual à listagem de empréstimos -->
              <ng-template
                let-loan
                appNamedTemplate="relationshipAccount.bankRelationship.financialInstitution.institutionName">
                <app-bank-logo
                  [code]="
                    loan.relationshipAccount.bankRelationship.financialInstitution.compensationCode
                  " />
                {{ loan.relationshipAccount.bankRelationship.financialInstitution.displayName }} |
                {{
                  loan.relationshipAccount.bankRelationship.financialInstitution.compensationCode
                }}
              </ng-template>

              <!-- Template para Moeda -->
              <ng-template appNamedTemplate="currency" let-loan>
                {{ loan.internationalCurrency?.currencyCode || '-' }}
              </ng-template>

              <!-- Template para Tipo dívida (traduzido) -->
              <ng-template appNamedTemplate="loanOperationType" let-loan>
                {{ getTranslatedLoanOperationType(loan.loanOperationType) }}
              </ng-template>

              <!-- Template para Possui Bench? -->
              <ng-template appNamedTemplate="hasBenchmark" let-loan>
                <span [class]="loan.hasBenchmark ? 'badge-success' : 'badge-warning'">
                  {{ loan.hasBenchmark ? 'Sim' : 'Não' }}
                </span>
              </ng-template>

              <ng-template #emptyTemplate let-items>
                <div class="empty">
                  <h3 class="subTitle">Nenhum empréstimo encontrado</h3>
                </div>
              </ng-template>
            </app-table>
          </div>
        </app-form-card>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="modal-footer">
      <app-button
        [label]="'Cancelar'"
        [type]="'button'"
        theme="white"
        (sendButtonClick)="closeModal()" />

      <app-button
        [label]="isLoading ? 'Salvando...' : 'Salvar Tudo'"
        [type]="'button'"
        [disabled]="!isFormValid() || isLoading"
        [isLoading]="isLoading"
        icon="pi pi-save"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>

<!-- Modal de Benchmark de Empréstimo -->
<app-dialog
  #loanBenchmarkDialog
  [key]="'modal-loan-benchmark'"
  [action]="'loan-benchmark'"
  [headerTheme]="'simple'"
  [title]="
    isEditModeLoanBenchmark ? 'Editar Benchmark do Empréstimo' : 'Cadastrar Benchmark do Empréstimo'
  "
  [maxWidth]="'600px'">
  <div class="loan-benchmark-modal" *ngIf="selectedLoanOperation">
    <!-- Loading State -->
    <div *ngIf="isLoadingLoanBenchmark" class="loading-container">
      <app-cog-loading-spinner></app-cog-loading-spinner>
      <p>Carregando informações do benchmark...</p>
    </div>

    <!-- Form Content -->
    <div *ngIf="!isLoadingLoanBenchmark">
      <!-- Loan Info -->
      <div class="loan-info">
        <h4>Empréstimo</h4>
        <p><strong>ID:</strong> {{ selectedLoanOperation.sequentialId }}</p>
        <p><strong>Contrato:</strong> {{ selectedLoanOperation.contractId }}</p>
        <p><strong>Valor:</strong> {{ selectedLoanOperation.value | currency: 'BRL' }}</p>
      </div>

      <!-- Benchmark Form -->
      <form [formGroup]="loanBenchmarkForm" appAutoFormGroup class="loan-benchmark-form">
        <app-form-card
          icon="pi pi-chart-line"
          title="Configuração do Benchmark"
          description="Configure o indexador e spread do benchmark para este empréstimo">
          <div class="fields-grid">
            <div class="field-container">
              <app-select
                [controlName]="'loan_indexer'"
                [label]="'Indexador'"
                [placeholder]="'Selecione o indexador'"
                [options]="indexerOptions">
              </app-select>
            </div>

            <div class="field-container">
              <app-input
                [type]="'number'"
                [controlName]="'loan_percentage'"
                [label]="'Spread (%)'"
                [placeholder]="'0,00'"
                [totalFractionDigits]="2"
                [required]="true"
                [min]="0"
                [max]="100">
              </app-input>
              <small class="form-help">Ex: CDI+4% (CDI + 4% a.a.)</small>
            </div>
          </div>

          <!-- Preview do Benchmark -->
          <div class="benchmark-preview" *ngIf="loanBenchmarkForm.valid">
            <div class="preview-card">
              <i class="pi pi-info-circle"></i>
              <div class="preview-content">
                <strong>Preview:</strong>
                <span class="preview-text">
                  {{ getLoanBenchmarkIndexerLabel() }} + {{ getLoanBenchmarkPercentageValue() }}%
                </span>
              </div>
            </div>
          </div>
        </app-form-card>
      </form>
    </div>
  </div>

  <ng-template #footer>
    <div class="modal-footer">
      <app-button
        [label]="'Cancelar'"
        [type]="'button'"
        theme="white"
        (sendButtonClick)="closeLoanBenchmarkModal()" />

      <app-button
        [label]="
          isLoadingLoanBenchmark
            ? 'Salvando...'
            : isEditModeLoanBenchmark
              ? 'Atualizar Benchmark'
              : 'Salvar Benchmark'
        "
        [type]="'button'"
        [disabled]="!isLoanBenchmarkFormValid() || isLoadingLoanBenchmark"
        [isLoading]="isLoadingLoanBenchmark"
        [icon]="isEditModeLoanBenchmark ? 'pi pi-check' : 'pi pi-save'"
        (sendButtonClick)="submitLoanBenchmarkAction()" />
    </div>
  </ng-template>
</app-dialog>
